module.exports = __webpack_public_path__ + "img/userProfileBackground.99861d75.svg";